import { Component } from '@angular/core';


export class SkyDemoAddressFormComponent { static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
  selector: 'sky-demo-address-form',
  template: `<div class="sky-emphasized" style="margin-bottom: 5px;">
  <label>Home</label>
</div>
<div>410 17th Street</div>
<div>Denver, CO 80202-4402</div>

<div class="sky-emphasized" style="margin: 5px 0 5px 0;">
  <label>Vacation</label>
</div>
<div>3345 Franciscan Way</div>
<div>Tampa, FL 10255-0098</div>
`
}, ] },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
